import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { useState, useEffect, useRef } from "react";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { baseUrlDefiner } from "../../utils/config";
import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import '../../components/table.css';
import styles from "../sellerlist/sellerList.module.css"
import { NodebaseUrlDefiner } from "../../utils/config";
import Sellerpagination from "../../components/Paginated/Sellerpagination";
import { Link } from "react-router-dom";
const { apiEndpoint } = config;

var $ = require('jquery');

var count = 1;
const Issueslists = () => {
    const [sellerList, setSellerList] = useState([]);
    useEffect(() => {
        fetchIssueList();
    }, [])

    const fetchIssueList = async () => {
        let apiEndpoint = NodebaseUrlDefiner();
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/igm/get_reverseIssue`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
            });
            console.log("all data", data);
            setSellerList(data?.data)

        } catch (error) {
            console.log("error", error);

            // setIsLoading(false);
        }
    }

    console.log(sellerList)

    const COLUMNS = [
        {
            Header: "Sn No.",
            Footer: "Sn No.",
            accessor: (row, count) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Issue Id",
            Footer: "Issue Id ",
            accessor: "issue_id",
            sticky: "left"
        },
        {
            Header: "Provider Id",
            Footer: "Provider Id",
            accessor: "ref_provider_id",
            sticky: "left"
        },
        {
            Header: "Transaction Id",
            Footer: "Transaction Id",
            accessor: "ref_transaction_id",
            sticky: "left"
        },
        {
            Header: "Level",
            Footer: "Level",
            accessor: "level",
            sticky: "left"
        },

        {
            Header: "Domain",
            Footer: "Domain",
            accessor: "domain",
            sticky: "left"
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: "status",
            sticky: "left"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row) => {
                
                return (
                    <>
                       <Link to={`../../raiseissue/${row.issue_id}`} className="btn btn-success btn-circle"> <i className="fas fa-eye"></i></Link>
                    </>
                )
            },
            sticky: "left"
        },


    ];
    count++

    const sellerDelete = async (id) => {
        let apiEndpoint = baseUrlDefiner();

    }


    return (
        <>
            <ThemeMaker>

                <div className="row w-100 m-0 mt-1">
                    <div className="col-md-12 ">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <h6 className="m-0 font-weight-bold text-primary text-left">
                                    Ticket list
                                </h6>


                            </div>

                            <div className={`card-body p-0 ${styles.cardbody}`}>
                                <div className="table-responsive">


                                    <div className={styles.sellerListing_desktop}>
                                        <Paginated data={sellerList} columns={COLUMNS} />
                                    </div>
                                    <div className={styles.sellerListing_mobile}>
                                        {/* <SellerTemplate data={sellerList} sellerDelete={sellerDelete}></SellerTemplate> */}
                                        <Sellerpagination itemsPerPage={20} items={sellerList} sellerDelete={sellerDelete} paginationFor="seller"></Sellerpagination>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* </div> */}
            </ThemeMaker>
        </>
    )
}

export default Issueslists;